"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _endpoints = require("../endpoints");
var _promiseCache = _interopRequireDefault(require("../utils/promise-cache"));
var _fetchWithAuth = _interopRequireDefault(require("../utils/fetch-with-auth"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DEFAULT_SEARCH_FIELDS = ['email', 'completeName', 'username', 'department', 'jobTitle'];
function RosterService(authState) {
  const fetch = new _fetchWithAuth.default(authState);
  const cache = new _promiseCache.default(authState);
  async function listHierarchies() {
    return await cache('listHierarchies', async () => {
      const res = await fetch(`${_endpoints.rosterURL}/hierarchies`);
      const data = await res.json();
      if (!res.ok) {
        throw data;
      }
      return data.hierarchies.sort((a, b) => a.name.localeCompare(b.name, undefined, {
        'sensitivity': 'base'
      }));
    })();
  }
  async function getHierarchy(hierarchyId) {
    return await cache(`getHierarchy:${hierarchyId}`, async () => {
      const res = await fetch(`${_endpoints.rosterURL}/hierarchies/${encodeURIComponent(hierarchyId)}`);
      const data = await res.json();
      if (!res.ok) {
        throw data;
      }
      return data;
    })();
  }
  async function listGroups() {
    return await cache('listGroups', async () => {
      const res = await fetch(`${_endpoints.rosterURL}/groups`);
      const data = await res.json();
      if (!res.ok) {
        throw data;
      }
      return data.data.sort((a, b) => a.name.localeCompare(b.name, undefined, {
        'sensitivity': 'base'
      }));
    })();
  }
  async function getGroup(groupId) {
    return await cache(`getGroup:${groupId}`, async () => {
      const res = await fetch(`${_endpoints.rosterURL}/groups/${encodeURIComponent(groupId)}`);
      const data = await res.json();
      if (!res.ok) {
        throw data;
      }
      return data;
    })();
  }
  async function searchPersons(searchText, searchFields = DEFAULT_SEARCH_FIELDS) {
    return await cache(`searchPersons:${searchText}`, async () => {
      const res = await fetch(`${_endpoints.rosterURL}/search`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          genericSearch: {
            searchFields,
            searchText
          },
          pageSize: 10
        })
      });
      const data = await res.json();
      if (!res.ok) {
        throw data;
      }
      return data.persons;
    })();
  }
  async function getPerson(personId) {
    return await cache(`getPerson:${personId}`, async () => {
      const res = await fetch(`${_endpoints.rosterURL}/persons/${encodeURIComponent(personId)}`);
      const data = await res.json();
      if (!res.ok) {
        throw data;
      }
      return data;
    })();
  }
  async function searchHierarchyNodes(hierarchyId, searchText) {
    return await cache(`searchHierarchyNodes:${hierarchyId}:${searchText}`, async () => {
      const res = await fetch(`${_endpoints.rosterURL}/hierarchies/${hierarchyId}/nodes/search`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          name: searchText,
          pageSize: 10
        })
      });
      const data = await res.json();
      if (!res.ok) {
        throw data;
      }
      return data.hierarchyNodes;
    })();
  }
  async function getHierarchyNode(hierarchyId, hierarchyNodeId) {
    return await cache(`getHierarchyNode:${hierarchyId}:${hierarchyNodeId}`, async () => {
      const res = await fetch(`${_endpoints.rosterURL}/hierarchies/${encodeURIComponent(hierarchyId)}/nodes/${encodeURIComponent(hierarchyNodeId)}`);
      const data = await res.json();
      if (!res.ok) {
        throw data;
      }
      return data;
    })();
  }
  async function findHierarchyIdForHierarchyNode(hierarchyNodeId) {
    return await cache(`findHierarchyIdForHierarchyNode:${hierarchyNodeId}`, async () => {
      const hierarchies = await listHierarchies();
      let hierarchyId = null;
      for (let i = 0; i < hierarchies.length; i++) {
        try {
          const hierarchyNode = await getHierarchyNode(hierarchies[i].id, hierarchyNodeId);
          hierarchyId = hierarchyNode.hierarchyId;
        } catch {
          hierarchyId = null;
        }
        if (hierarchyId) {
          break;
        }
      }
      return hierarchyId;
    })();
  }
  return {
    listHierarchies,
    getHierarchy,
    listGroups,
    getGroup,
    searchPersons,
    getPerson,
    searchHierarchyNodes,
    getHierarchyNode,
    findHierarchyIdForHierarchyNode
  };
}
var _default = exports.default = RosterService;
//# sourceMappingURL=roster.js.map